<span translate [translateParams]="{ time: timer | async }">
  Common.lblCodeExpire
</span>
